module.exports = __webpack_public_path__ + "img/base_divers_office_tourisme.025e9279.svg";